import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const SliderItemStyle = styled.div`
	padding: ${rem(14, 20, 14, 14)};
	display: flex;
	flex-flow: row wrap;
	height: 100%;
	align-items: center;
	background-color: ${({ theme }) => theme.color.grayEight};
	border-radius: ${rem(4)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background-color: transparent;
			border: ${rem(1)} solid ${({ theme }) => theme.color.primary};
		`}

	@media (${device.tablet}) {
		padding: ${rem(10)};
		align-items: flex-start;
	}
	${(p) =>
		p.bgLittleDark &&
		css`
			background-color: ${({ theme }) => theme.color.graySeventeen};
		`}
`
export const Title = styled.div`
	font-size: ${rem(16)};
	line-height: ${rem(24)};
	padding: ${rem(20, 0)};
	font-weight: 700;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			font-size: ${rem(15)};
		`}

	@media (${device.tablet}) {
		padding: ${rem(10)};
		font-size: ${rem(14)};
		line-height: ${rem(18)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}
`
